import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Pages } from '../../../../types/offers';
import SelectConnector from '../../containers/shared/connectors/select-connector';
import { selectConnector } from '../../lib/side-effects/connectors';
import { goToNextOfferStep } from '../../lib/side-effects/offer-flow';
import { stepNames } from '../../lib/side-effects/progress-bar';
import { selectState } from '../../selectors';
import { setCurrentOfferPage } from '../../store/offer';
import { setConnectorValidationStatus } from '../../store/order';

const SelectConnectorContainer = () => {
  const dispatch = useDispatch();
  const state = useSelector(selectState);
  const history = useHistory();

  useEffect(() => {
    dispatch(setCurrentOfferPage(Pages.SelectConnector));
    dispatch(setProgressBarCurrentStep(stepNames.selectConnector));
  }, []);

  const onSelectConnector = () => {
    dispatch(selectConnector(state.avataxSignup.selectedConnector?.id || ''));
    dispatch(setConnectorValidationStatus(true));
    dispatch(goToNextOfferStep({ history }));
  };

  return <SelectConnector onSelectConnector={onSelectConnector} isBannerHidden={true} />;
};

export default SelectConnectorContainer;
